import { Box, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";

const PlaceholderSection = () => {
  const { t } = useTranslation("questEditor");

  return (
    <Paper
      elevation={0}
      sx={{
        border: 1,
        borderColor: "divider",
        flexGrow: 1,
        minHeight: 200,
      }}
    >
      <SectionHeader title={t("order_review.section.xxx")} />
      <Box p={2} />
    </Paper>
  );
};

export default PlaceholderSection;
